export default "__VITE_ASSET__Bsqooxpu__"